import { BookOpen, LibraryBig } from "lucide-react";

export function SearchResultCard({
  title,
  author,
  coverUrl,
  tags,
  description,
  sourceCount,
  latestChapterTitle,
  index,
  onClick,
}: {
  title: string;
  author?: string;
  coverUrl?: string;
  tags?: string[];
  description?: string;
  sourceCount: number;
  latestChapterTitle?: string;
  index: number;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="group grid w-full grid-cols-[4rem_1fr] gap-3 rounded-2xl border bg-card p-3 text-left shadow-sm transition duration-200 animate-in fade-in slide-in-from-bottom-2 hover:-translate-y-0.5 hover:border-foreground/25 hover:shadow-md sm:grid-cols-[5rem_1fr_auto] sm:gap-4"
      style={{ animationDelay: `${Math.min(index, 8) * 35}ms` }}
    >
      <BookCover title={title} coverUrl={coverUrl} />

      <div className="min-w-0">
        <div className="flex min-w-0 items-start gap-2">
          <div className="min-w-0 flex-1">
            <h3 className="truncate text-base font-semibold leading-6">{title}</h3>
            <p className="mt-0.5 text-xs text-muted-foreground">{author ?? "未知作者"}</p>
          </div>
          <span className="rounded-full bg-foreground px-2 py-1 text-[11px] font-semibold leading-none text-background sm:hidden">
            {sourceCount} 源
          </span>
        </div>

        {Boolean(tags?.length) && (
          <div className="mt-2 flex flex-wrap gap-1">
            {tags?.slice(0, 3).map(tag => (
              <span key={tag} className="rounded-full border bg-background px-2 py-0.5 text-[11px] leading-none text-muted-foreground">
                {tag}
              </span>
            ))}
          </div>
        )}

        <p className="mt-2 line-clamp-2 text-sm leading-6 text-muted-foreground">{description ?? "暂无简介"}</p>

        <div className="mt-3 flex items-center gap-2 text-xs text-muted-foreground">
          <LibraryBig className="size-3.5 shrink-0" />
          <span className="truncate">{latestChapterTitle ?? "暂无最新章节"}</span>
        </div>
      </div>

      <div className="hidden h-full min-w-22 items-start justify-end sm:flex">
        <span className="rounded-full bg-foreground px-2.5 py-1 text-[11px] font-semibold leading-none text-background">
          {sourceCount} 个来源
        </span>
      </div>
    </button>
  );
}

function BookCover({ title, coverUrl }: { title: string; coverUrl?: string }) {
  return (
    <div className="aspect-[3/4] overflow-hidden rounded-xl border bg-muted text-muted-foreground shadow-inner">
      {coverUrl ? (
        <img src={coverUrl} alt={title} className="h-full w-full object-cover" loading="lazy" />
      ) : (
        <span className="flex h-full w-full items-center justify-center">
          <BookOpen className="size-5" />
        </span>
      )}
    </div>
  );
}
